import React from 'react';
import Layout from '../components/Layout';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

function PrivacyPage() {
  var { t } = useTranslation();

  return (
    <Layout>
      <SEO title={PAGE_SEO['privacy'].title} description={PAGE_SEO['privacy'].description} url="/privacy" />
      <div className="pt-32 pb-20 bg-black min-h-screen">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{t('privacyTitle')}</h1>
          <p className="text-neutral-500 mb-12">{t('termsLastUpdated')}: December 22, 2025</p>

          <div className="space-y-8 text-neutral-300">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. {t('privacyIntro')}</h2>
              <p>{t('privacyIntroText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. {t('privacyCollect')}</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-white mb-2">{t('privacyPersonal')}</h3>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Name and email address</li>
                    <li>Profile photo (optional)</li>
                    <li>Location (city, country)</li>
                    <li>Phone number, WhatsApp, social media handles (optional)</li>
                    <li>Musical background and instrument preferences</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-medium text-white mb-2">{t('privacyInstrument')}</h3>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Serial numbers and model information</li>
                    <li>Instrument photos</li>
                    <li>Ownership and transfer history</li>
                    <li>Condition and purchase details</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. {t('privacyUse')}</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Create and manage your account</li>
                <li>Register and track your instruments</li>
                <li>Facilitate instrument transfers between users</li>
                <li>Send stolen/lost instrument alerts to nearby musicians</li>
                <li>Connect you with other musicians</li>
                <li>Improve our services and user experience</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. {t('privacySharing')}</h2>
              <p className="mb-4">{t('privacySharingText')}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>With other users (only information you choose to make public)</li>
                <li>When you report an instrument as stolen/lost</li>
                <li>With service providers who assist our operations</li>
                <li>When required by law</li>
              </ul>
              <p className="mt-4 font-semibold text-[#d4af37]">{t('privacyNeverSell')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. {t('privacySecurity')}</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Encrypted data transmission (SSL/TLS)</li>
                <li>Secure cloud storage</li>
                <li>Regular security audits</li>
                <li>Access controls and authentication</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. {t('privacyRights')}</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate information</li>
                <li>Delete your account and data</li>
                <li>Export your instrument data</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. {t('privacyContactUs')}</h2>
              <p>
                {t('privacyContactText')}{' '}
                <a href="mailto:trumpet95@hotmail.com" className="text-[#d4af37] hover:underline">
                  trumpet95@hotmail.com
                </a>
              </p>
            </section>

            <section className="border-t border-neutral-800 pt-8">
              <p className="text-neutral-500 text-sm">© 2025 ToneRegistry. All rights reserved.</p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default PrivacyPage;
